/** Return a string for the first metadata line from `data` */
export function metadataLineOne(data) {
  return data?.['metadata_line_one'] ?? '';
}

/** Return a string for the second metadata line from `data` */
export function metadataLineTwo(data) {
  return data?.['metadata_line_two'] ?? '';
}

/** Return a string for the third metadata line from `data` */
export function metadataLineThree(data) {
  return data?.['metadata_line_three'] ?? '';
}
